import {createSelector} from 'reselect';
import props from '../props';

export default createSelector(
    props.app.bitcoin_profit,
    (bitcoin_profit) => {
        return {
            bitcoin_profit
        }
    }
)